import { __rest } from 'tslib';
import React from 'react';
import Icon from '@ant-design/icons';
import { I as IconBase } from '../IconBase-df74767e.js';

const IconComponent = (props, ref) => {
    const data = {
        tag: 'svg',
        attr: { viewBox: '0 0 16 16', fill: 'none' },
        child: [
            {
                tag: 'path',
                attr: {
                    fillRule: 'evenodd',
                    clipRule: 'evenodd',
                    d: 'M14.296 0.84C14.632 1.072 14.928 1.368 15.16 1.704C15.712 2.464 16 3.456 16 4.648V11.352C16 14.264 14.264 16 11.352 16H4.648C4.488 16 4.328 15.992 4.176 15.984C3.192 15.92 2.36 15.64 1.704 15.16C1.368 14.928 1.072 14.632 0.84 14.296C0.288 13.536 0 12.544 0 11.352V4.648C0 1.896 1.552 0.192 4.176 0.024C4.328 0.00799998 4.488 0 4.648 0H11.352C12.544 0 13.536 0.288 14.296 0.84ZM12.8 6.12C13.128 6.12 13.4 5.848 13.4 5.52H13.392V4.576C13.392 3.656 12.648 2.912 11.728 2.912H4.264C3.344 2.912 2.6 3.656 2.6 4.576V5.52C2.6 5.848 2.872 6.12 3.2 6.12C3.528 6.12 3.8 5.848 3.8 5.52V4.576C3.8 4.51507 3.812 4.45473 3.83532 4.39844C3.85864 4.34214 3.89282 4.29099 3.9359 4.2479C3.97899 4.20482 4.03014 4.17064 4.08643 4.14732C4.14273 4.124 4.20307 4.112 4.264 4.112H7.4V7.20002H1.60003C1.15821 7.20002 0.800034 7.5582 0.800034 8.00002C0.800034 8.44185 1.15821 8.80002 1.60003 8.80002H7.4V11.888H5.976C5.648 11.888 5.376 12.16 5.376 12.488C5.376 12.816 5.648 13.088 5.976 13.088H10.024C10.352 13.088 10.624 12.816 10.624 12.488C10.624 12.16 10.352 11.888 10.024 11.888H8.6V8.80002H14.4C14.8419 8.80002 15.2 8.44185 15.2 8.00002C15.2 7.5582 14.8419 7.20002 14.4 7.20002H8.6V4.112H11.736C11.7969 4.112 11.8573 4.124 11.9136 4.14732C11.9699 4.17064 12.021 4.20482 12.0641 4.2479C12.1072 4.29099 12.1414 4.34214 12.1647 4.39844C12.188 4.45473 12.2 4.51507 12.2 4.576V5.52C12.2 5.848 12.472 6.12 12.8 6.12Z',
                    fill: '#7D7D7D',
                },
            },
        ],
    };
    const { style } = props;
    const _a = style || {}, { fontSize, color: passColor } = _a, rest = __rest(_a, ["fontSize", "color"]);
    const size = fontSize || 16;
    const color = passColor;
    return (React.createElement(Icon, Object.assign({}, props, { style: rest, ref: ref, component: () => (React.createElement(IconBase, { color: color, size: size, data: data, overrideColor: true })) })));
};
const LineThroughOutlined = React.forwardRef(IconComponent);
LineThroughOutlined.displayName = 'LineThroughOutlined';

export { LineThroughOutlined };
